import styled from '@emotion/styled';
import { IconAndTextButton } from '@blueprint/ui';
import { css } from '@emotion/react';

export const CloseIconButton = styled.button(
    () => css`
        display: flex;
        align-items: center;
        background: transparent;
        border: 0;
        cursor: pointer;
        height: 36px;
        width: 36px;
    `
);

export const CloseIconWithTextStyles = styled(IconAndTextButton)(
    ({ theme }) => css`
        display: flex;
        text-align: center;
        background-color: ${theme.colors.white};
        background: transparent;
        padding: 0;
        height: 44px;

        &:hover {
            background-color: ${theme.colors.white};
        }
    `
);
